import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "search-box position-relative me-15" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_21 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium"
}
const _hoisted_22 = {
  key: 1,
  class: "shadow-none lh-1 fw-medium"
}
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_30 = { class: "dropdown" }
const _hoisted_31 = { class: "dropdown-menu" }
const _hoisted_32 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_33 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_34 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 1,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 2,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  class: "modal fade",
  id: "create-task",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_45 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_46 = { class: "modal-content" }
const _hoisted_47 = { class: "modal-body px-4" }
const _hoisted_48 = { class: "row gy-2" }
const _hoisted_49 = { class: "col-md-4-3" }
const _hoisted_50 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaginationComponent2 = _resolveComponent("PaginationComponent2")!
  const _component_EditEtatContrat = _resolveComponent("EditEtatContrat")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "btn btn-primary",
            to: "/ajouter-contrat"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
              _createTextVNode(" Ajouter un contrat ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un contrat"
            }, null, 512), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Marché ", -1)),
                _createVNode(_component_Field, {
                  modelValue: _ctx._marche,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._marche) = $event)),
                  name: "marche"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.marchesOptions,
                      "preserve-search": true,
                      multiple: false,
                      searchable: true,
                      placeholder: "Sélectionner le marché",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "marche",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Type ", -1)),
                _createVNode(_component_Field, {
                  modelValue: _ctx._type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._type) = $event)),
                  name: "type"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.typesOptions,
                      "preserve-search": true,
                      multiple: false,
                      searchable: true,
                      placeholder: "Sélectionner le type",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "type",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date de création", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._dateR) = $event)),
                  class: "form-control",
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)))
                }, null, 544), [
                  [_vModelText, _ctx._dateR]
                ])
              ])
            ])
          ])
        ])
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("table", _hoisted_17, [
            _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Référence "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Mise en application "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Code Place "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Marchand "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Marché "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Type "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Loyer "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Montant contrat "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Date "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Statut "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                }, " Actions ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contrats, (contrat, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_18, _toDisplayString(contrat?.reference), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.format_Date(contrat.dateMiseEnService)), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(contrat?.place?.code), 1),
                  (contrat?.usager?.raisonSocial == null)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(contrat?.usager?.nom + " " + contrat?.usager?.prenom), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString((contrat?.usager?.sigle) ?
                  " [ " + contrat?.usager?.sigle + " ] " + contrat?.usager?.raisonSocial
                  : contrat?.usager?.raisonSocial), 1)),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(contrat?.place?.marche?.libelle), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(contrat?.place?.type?.type?.libelle), 1),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(contrat.loyer), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(contrat?.montantContrat), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.format_Date(contrat.createdAt)), 1),
                  _createElementVNode("td", _hoisted_28, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getStatutBadge(contrat?.statut).badgeClass)
                    }, _toDisplayString(_ctx.getStatutBadge(contrat.statut).text), 3)
                  ]),
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _cache[17] || (_cache[17] = _createElementVNode("button", {
                        class: "btn btn-sm btn-primary",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, " Actions ", -1)),
                      _createElementVNode("ul", _hoisted_31, [
                        _createElementVNode("li", _hoisted_32, [
                          _createVNode(_component_router_link, {
                            to: {
                        name: 'ViewContratPage',
                        params: { id: contrat.id },
                      }
                          }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Détails ")
                            ])),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("li", _hoisted_33, [
                          _createVNode(_component_router_link, {
                            to: {
                        name: 'EditContratPage',
                        params: { id: contrat.id },
                      }
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Modifier ")
                            ])),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("li", _hoisted_34, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.openNewWindow(contrat)),
                            type: "button"
                          }, _cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Aperçu du contrat ")
                          ]), 8, _hoisted_35)
                        ]),
                        _createElementVNode("li", _hoisted_36, [
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.regenererEtImprimer(contrat))
                          }, _cache[13] || (_cache[13] = [
                            _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Réimprimer (mis à jour) ")
                          ]), 8, _hoisted_37)
                        ]),
                        (contrat.statut !== 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (
                        _ctx.suppression(contrat.id, _ctx.contrats, 'contrats', `Contrat ${contrat.id}`)
                        )
                              }, _cache[14] || (_cache[14] = [
                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Désactiver ")
                              ]), 8, _hoisted_39)
                            ]))
                          : _createCommentVNode("", true),
                        (contrat.statut !== 2)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                "data-bs-target": "#create-task",
                                "data-bs-toggle": "modal",
                                onClick: ($event: any) => (_ctx.openModal(contrat.id))
                              }, _cache[15] || (_cache[15] = [
                                _createElementVNode("i", { class: "flaticon-close lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Resiliation ")
                              ]), 8, _hoisted_41)
                            ]))
                          : _createCommentVNode("", true),
                        (contrat.statut !== 1)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.modififContratId(contrat.id)),
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddContratModal"
                              }, _cache[16] || (_cache[16] = [
                                _createElementVNode("i", { class: "flaticon-unlock lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode("Activer ")
                              ]), 8, _hoisted_43)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "modal-header" }, [
                _createElementVNode("h6", { class: "modal-title" }, "Voulez-vous résilier ce contrat ?"),
                _createElementVNode("button", {
                  type: "button",
                  id: "close-modal",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_Form, {
                  ref: "contratsForm",
                  onSubmit: _ctx.addContrats,
                  "validation-schema": _ctx.contratsSchema
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block fw-semibold mb-10" }, [
                          _createTextVNode(" Motif"),
                          _createElementVNode("span", { class: "text-danger" })
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "motifAnnuler",
                          as: "textarea",
                          placeholder: "Entrer le motif",
                          class: "form-control shadow-none rounded-0 text-black"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "motifAnnuler",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-footer" }, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary"
                      }, "Annuler"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      }, " Fermer ")
                    ], -1))
                  ]),
                  _: 1
                }, 8, ["onSubmit", "validation-schema"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createVNode(_component_PaginationComponent2, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_EditEtatContrat, {
      onGetAllContrat: _ctx.getAllContrats,
      id: _ctx.contratId,
      onOpenmodal: _ctx.showModalEdite,
      onClose: _ctx.getAllContrats
    }, null, 8, ["onGetAllContrat", "id", "onOpenmodal", "onClose"])
  ], 64))
}